import React, { useContext, useEffect, useState } from "react";
import swal from "sweetalert";
import { billpunchbasicauth } from "../../utils/Credentials";
import { GlobalContext } from "../../Context/GlobalState";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
import { AddProjectAdminModal } from "../Modal";
import { useNavigate } from "react-router-dom";
import { FiLayers, FiFileText, FiFolder, FiUsers, FiEye, FiZap, FiCheck } from "react-icons/fi";
import { IoColorPaletteOutline } from "react-icons/io5";
import "./Createworkspaceadmin.css";

const WorkspaceIcon = ({ children }) => <span className="acw-icon">{children}</span>;
const Createworkspaceadmin = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [activeStep, setActiveStep] = useState(1);
  const [formData, setFormData] = useState({
    workspaceName: "",
    workspaceDesc: "",
    teamSize: "",
    workspaceDescription: "",
    colorCode: "#FDBF60",
    projectId: "",
  });

  const { password, username } = billpunchbasicauth;
  const navigate = useNavigate();
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [projects, setProjects] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "projectId" && value === "createProject") {
      openaddprojectModal();
      return;
    }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleColorSelect = (color) => {
    setFormData({
      ...formData,
      colorCode: color,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (formData.workspaceName.trim() === "") {
      swal("Error", "Please enter workspace name.", "error");
      return;
    } else if (formData.colorCode === "") {
      swal("Error", "Please select an avatar color.", "error");
      return;
    } else if (formData.projectId === "") {
      swal("Error", "Please select a project.", "error");
      return;
    } else if (formData.teamSize === "") {
      swal("Error", "Please select team size.", "error");
      return;
    } else if (formData.workspaceDescription.trim() === "") {
      swal("Error", "Please enter workspace description.", "error");
      return;
    }

    {
      console.log("Form submission started.");
      try {
        setIsSubmitting(true);
        setTransactionLoaderState(true);
        const base64Credentials = btoa(`${username}:${password}`);

        var raw = JSON.stringify({
          firmid: user.firm_id,
          name: formData.workspaceName,
          desc: formData.workspaceDescription,
          empid: user.userid,
          ownername: user.username,
          teamsize: formData.teamSize,
          colorcode: formData.colorCode,
          project_id: formData.projectId,
        });

        console.log("Request sending:", raw);

        var requestOptions = {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: raw,
          redirect: "follow",
        };

        console.log("Sending data to API.");
        const res = await fetch(
          `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/AddWorkSpace`,
          requestOptions
        );
        console.log("API URL");
        const data = await res.json();
        console.log("API response:", data);
        if (data.status === "1") {
          swal("Error", data.result, "error");
          setTransactionLoaderState(false);
        } else {
          swal("Success", data.result, "success");
          setTransactionLoaderState(false);
          navigate("/admin/work-dashboard");
        }
        console.log("Form submission completed.");
      } catch (error) {
        console.log("Error:", error);
        swal("Error", "Unable to create workspace. Please try again.", "error");
      } finally {
        setIsSubmitting(false);
        setTransactionLoaderState(false);
      }
    }
  };

  const fetchProject = async () => {
    setTransactionLoaderState(true);
    try {
        const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmid: user.firm_id,
        created_by: "Admin",
      });

      var requestOptions = {
        method: "POST",
        headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmProjects`,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setProjects(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
    setTransactionLoaderState(false);
  };

  useEffect(() => {
    fetchProject();
  }, []);

  const [showaddprojectModal, setshowaddprojectModal] = useState(false);
  const openaddprojectModal = () => {
    setshowaddprojectModal(true);
  };

  const closeaddprojectModal = () => {
    setshowaddprojectModal(false);
  };

  const completedSteps = [
    Boolean(formData.workspaceName.trim()),
    Boolean(formData.colorCode),
    Boolean(formData.projectId),
    Boolean(formData.teamSize),
    Boolean(formData.workspaceDescription.trim()),
  ];

  const selectedProject = projects.find(project => String(project.pk_project_id) === String(formData.projectId));
  const initial = formData.workspaceName.trim().charAt(0).toUpperCase() || "A";
  const colors = ["#FDBF60", "#58A399", "#ACE2E1", "#FF8E8F", "#E1AFD1", "#C5EBAA", "#B7C9F2", "#F2E18C"];
  const avatar = <div className="acw-avatar" style={{ backgroundColor: formData.colorCode }}>{initial}</div>;

  return (
    <div className="acw-page">
      <AddProjectAdminModal show={showaddprojectModal} closeModal={closeaddprojectModal} getProjects={fetchProject} />
      <header className="acw-header">
        <WorkspaceIcon><FiLayers /></WorkspaceIcon>
        <div><h1>Create New Workspace</h1><p>Set up your workspace details, team, and project in one place.</p></div>
      </header>
      <ol className="acw-steps" aria-label="Workspace setup progress">
        {["Workspace Name", "Avatar", "Assign Project", "Team Size", "Description"].map((label, index) => (
          <li key={label} className={[activeStep === index + 1 ? "is-active" : "", completedSteps[index] ? "is-complete" : ""].filter(Boolean).join(" ")} aria-current={activeStep === index + 1 ? "step" : undefined}>
            <span aria-label={completedSteps[index] ? `Step ${index + 1} completed` : `Step ${index + 1}`}>
              {completedSteps[index] ? <FiCheck aria-hidden="true" /> : index + 1}
            </span>
            {label}
          </li>
        ))}
      </ol>
      <form onSubmit={handleSubmit}>
        <fieldset disabled={isSubmitting} className="acw-fieldset">
          <div className="acw-layout">
            <div className="acw-fields">
              <section className="acw-section" onFocus={(event) => setActiveStep(event.target.name === "workspaceDescription" ? 5 : 1)}>
                <div className="acw-section-heading"><WorkspaceIcon><FiFileText /></WorkspaceIcon><div><h2>1. Workspace Details</h2><p>Give your workspace a name and description.</p></div></div>
                <div className="acw-details">
                  <label htmlFor="acw-name">Workspace Name <span className="acw-required">*</span></label>
                  <input id="acw-name" name="workspaceName" value={formData.workspaceName} onChange={handleChange} placeholder="Enter workspace name" />
                  <label htmlFor="acw-description">Workspace Description <span className="acw-required">*</span></label>
                  <div><textarea id="acw-description" name="workspaceDescription" value={formData.workspaceDescription} onChange={handleChange} onFocus={() => setActiveStep(5)} placeholder="Enter workspace description" maxLength={500} /><span className="acw-count">{formData.workspaceDescription.length}/500</span></div>
                </div>
              </section>
              <section className="acw-section" onFocus={() => setActiveStep(2)}>
                <div className="acw-section-heading"><WorkspaceIcon><IoColorPaletteOutline /></WorkspaceIcon><div><h2>2. Workspace Avatar</h2><p>Choose a color for your workspace avatar.</p></div></div>
                <div className="acw-avatar-options">{avatar}<div className="acw-colors" aria-label="Avatar color">{colors.map(color => <button key={color} type="button" aria-label={`Select avatar color ${color}`} aria-pressed={formData.colorCode === color} className={formData.colorCode === color ? "is-selected" : ""} style={{ backgroundColor: color }} onClick={() => handleColorSelect(color)} />)}</div></div>
              </section>
              <section className="acw-section acw-inline" onFocus={() => setActiveStep(3)}>
                <div className="acw-section-heading"><WorkspaceIcon><FiFolder /></WorkspaceIcon><div><h2><label htmlFor="acw-project">3. Assign Project</label></h2><p>Select a project to associate with this workspace.</p></div></div>
                <div className="acw-control"><select id="acw-project" name="projectId" value={formData.projectId} onChange={handleChange}><option value="">Select a Project</option><option value="createProject">+ Create Project</option>{projects.map(project => <option key={project.pk_project_id} value={project.pk_project_id}>{project.project_name}</option>)}</select>
                  {projects.length > 0 && <div className="acw-popular"><span>Popular Projects:</span>{projects.slice(0, 3).map(project => <button key={project.pk_project_id} type="button" onClick={() => setFormData({ ...formData, projectId: String(project.pk_project_id) })}>{project.project_name}</button>)}</div>}
                </div>
              </section>
              <section className="acw-section acw-inline" onFocus={() => setActiveStep(4)}>
                <div className="acw-section-heading"><WorkspaceIcon><FiUsers /></WorkspaceIcon><div><h2><label htmlFor="acw-team">4. Team Size</label></h2><p>Select the number of team members in this workspace.</p></div></div>
                <div className="acw-control"><select id="acw-team" name="teamSize" value={formData.teamSize} onChange={handleChange}><option value="">Select team size</option>{["1-5", "6-10", "11-20", "21-50", "51-100", "101+"].map(size => <option key={size} value={size}>{size}</option>)}</select><div className="acw-team-options">{["1-5", "6-10", "11-20"].map(size => <button key={size} type="button" className={formData.teamSize === size ? "is-selected" : ""} aria-pressed={formData.teamSize === size} onClick={() => setFormData({ ...formData, teamSize: size })}><FiUsers />{size.replace("-", " - ")}</button>)}</div></div>
              </section>
            </div>
            <aside className="acw-sidebar">
              <section className="acw-preview">
                <div className="acw-section-heading"><WorkspaceIcon><FiEye /></WorkspaceIcon><div><h2>Workspace Preview</h2><p>Here's how your workspace will look.</p></div></div>
                <div className="acw-preview-card"><div className="acw-preview-identity">{avatar}<div><h3>{formData.workspaceName || "Workspace Name"}</h3><p>{formData.workspaceDescription || "Workspace description will appear here."}</p></div></div><div className="acw-preview-row"><WorkspaceIcon><FiFolder /></WorkspaceIcon><span>Project</span><span>{selectedProject?.project_name || "Not selected"}</span></div><div className="acw-preview-row"><WorkspaceIcon><FiUsers /></WorkspaceIcon><span>Team Size</span><span>{formData.teamSize || "Not selected"}</span></div></div>
              </section>
              <section className="acw-tips"><div className="acw-section-heading"><WorkspaceIcon><FiZap /></WorkspaceIcon><h2>Quick Tips</h2></div><ul><li>Choose a clear and recognizable workspace name.</li><li>Add a meaningful description to help your team.</li><li>Select the right project and team size for better organization.</li><li>You can always edit these details later.</li></ul></section>
            </aside>
          </div>
          <footer className="acw-actions"><button type="button" className="acw-cancel" onClick={() => navigate("/admin/work-dashboard")}>Cancel</button><button type="submit" className="acw-submit">{isSubmitting ? "Creating Workspace…" : "Create Workspace"}</button></footer>
          {isSubmitting && <p className="acw-status" role="status">Please wait while your workspace is being created.</p>}
        </fieldset>
      </form>
    </div>
  );
};

export default Createworkspaceadmin;
